import Vue from 'vue';
import Vuex from 'vuex';
import { accountStore } from '../store/accountStore';
import { translationStore } from '../store/translationStore';
import { cartStore } from '../store/cartStore';
import { filterStore } from '@/store/filterStore';
import { pagesStore } from '@/store/pages/pagesStore';
import { checkoutStore } from '@/store/checkoutStore';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    accountStore,
    translationStore,
    cartStore,
    filterStore,
    pagesStore,
    checkoutStore
  }
});

export default store;
export const useStore = () => store;
